// 3rd-party modules
import { useEffect, useState } from "react";

// project modules
import Button from "../shared/button";
import Loader from "../shared/loader";
import { apiCall } from "../../helpers/apiHelper";

// apis
import * as ProductApi from '../../apis/productApi';

// models
import { Product } from "../../models/product";

type Props = {
  accountId?: Number;
  deviceType?: string;
  cancelText?: string;
  okText?: string;
  refresh?: boolean;
  selectedProduct?: Product | null;
  onCancel?: () => void;
  onSave?: (product: Product) => void;
};

const getProducts = async (deviceType?: string, abortSignal?: AbortSignal) => {
  // const queryParts = ["active:'true'"];
  // queryParts.push("metadata['IsSubscription']:'true'");
  // if (deviceType) {
  //   queryParts.push(`metadata['Type']:'${deviceType}'`);
  // }

  // const query = queryParts.join(" AND ");

  const response = await apiCall(ProductApi.getProducts({ "expand": ["data.default_price"] }, abortSignal));

  const data = response.success ? response.data?.value : [];

  const subsList = data.filter((x: any) => x.metadata?.IsSubscription === "true" && x.metadata?.Type === deviceType)

  return response.success ? Product.toArrayOfClass(subsList) : [];
};

export default function AccountSubscription({ accountId, deviceType, cancelText = "Cancel", okText = "Save Changes", refresh, onCancel, onSave }: Props) {
  const abortController = new AbortController();
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  useEffect(() => {
    const getProductsAsync = async () => {
      setLoading(true);
      setProducts(await getProducts(deviceType, abortController.signal))
      setLoading(false);
    }

    getProductsAsync();
  }, []);

  const onCancelClick = () => {
    if (onCancel) {
      onCancel();
    }
  }

  const onCardSelect = (item: Product) => {
    setSelectedProduct(item);
  }

  const onSubmit = async () => {
    if (selectedProduct != null) {
      if (onSave) onSave(selectedProduct);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <form
      data-length="auto"
      data-type="group"
      >
        <space data-height="40"></space>
        <group
          data-direction="column"
          data-align="start"
          data-gap="10">
          <group
            data-firection="column"
            data-gap="30"
            data-grid-template="300"
            data-type="grid">
            {
              products.map(item =>
                <group
                  key={item.productId}
                  data-elevation="5"
                  data-radius="15"
                  data-align="center"
                  data-justify="center"
                  data-direction="column"
                  data-gap="20"
                  data-space="30"
                  data-background="main-background"
                  data-shrink="0"
                  className={`fee_plan_selector${item.productId === selectedProduct?.productId ? " selected" : ""}`}
                  onClick={() => onCardSelect(item)}>
                  <group data-gap="10" data-direction="column">
                    <group data-align="center" data-gap="5">
                      <text data-wrap="wrap" data-weight="500" data-text-size="large">Ki<text data-weight="900" data-text-size="large">bosh</text></text>
                      <text data-wrap="wrap" data-uppercase data-accent="" data-weight="900" data-text-size="large">{item.name}</text>
                    </group>
                    <text data-wrap="wrap" data-weight="700" data-text-size="large">${((item.price?.unitAmount || 0) / 100).toFixed(2)}</text>
                    <group data-gap="10" data-weight="700">
                      <group>
                        <text data-ellipsis="" data-wrap="wrap" >
                          {" "}
                          {item.description}{" "}
                        </text>
                      </group>
                    </group>
                  </group>
                  <group>
                    <Button primary rounded data-space-horizontal="20" onClick={() => onCardSelect(item)}>
                      <text>Select</text>
                    </Button>
                  </group>
                </group>
              )
            }
          </group>
        </group>
        <space data-height="40"></space>
        <group
          data-align="center"
          data-gap="10"
        >
          <Button large material outline data-length="forcefit" onClick={onCancelClick}>
            <text data-space-horizontal="20">{cancelText}</text>
          </Button>
          <Button data-length="forcefit" disabled={selectedProduct == null} large material primary onClick={onSubmit}>
            <text>{okText}</text>
          </Button>
        </group>
        <space data-height="40" data-adaptive="mobile"></space>
      </form>
    </>
  );
}
